import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import s from './ConstituencyWrapper.scss';
import ConstituencyWidget from '../ConstituencyWidget/ConstituencyWidget';
import ConstituencyCandidateVersus from '../ConstituencyCandidateVersus';
import HeaderTab from '../../../routes/home/components/desktop/HeaderTabV2';
import {
  filterSearchSortData,
  loadYearWiseConstituencyData,
} from '../../../routes/newslisting/redux';
import LoaderSpinner from '../LoaderSpinner';
import SortSelect from '../SortSelect';
import InputSearch from '../InputSearch';
// import Link from '../../../components/Link/Link';

class ConstituencyListWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sort: { alpha: 1, key: 'slug' },
      sortText: { name: 'Alphabet', seoname: 'Alphabet' },
      searches:
        props.force &&
        Array.isArray(props.loksabhaStates) &&
        props.loksabhaStates.length > 0
          ? { sn: props.loksabhaStates[0].seoname }
          : {},
      currentState:
        props.force &&
        Array.isArray(props.loksabhaStates) &&
        props.loksabhaStates.length > 0
          ? props.loksabhaStates[0]
          : {
              name: 'All India',
              seoname: '',
            },
    };

    try {
      const { electionData } = props?.sectionItem?.items || {};
      const liveData =
        Object.values(electionData) &&
        Array.isArray(Object.values(electionData)) &&
        Object.values(electionData).filter(data => data.live);
      if (liveData && Array.isArray(liveData) && liveData.length) {
        const { live, source } = Object.values(electionData).filter(
          data => data.live,
        )[0];
        this.state.live = live;
        this.state.source = source;
        this.state.selectedYear = Object.values(electionData).sort(
          (a, b) => b.year - a.year,
        )[0].year;
      }
    } catch (error) {
      //
    }
    this.sortMapping = [
      {
        method: 'alpha',
        name: 'Alphabet',
        seoname: 'alphabet',
        order: 1,
        key: 'slug',
      },
    ];
    this.DEBOUNCE_DELAY = 500;
  }

  componentDidMount() {
    const { electionData } = this.props.sectionItem.items;
    if (electionData) {
      const liveData =
        Object.values(electionData) &&
        Array.isArray(Object.values(electionData)) &&
        Object.values(electionData).filter(data => data.live);
      if (liveData && Array.isArray(liveData) && liveData.length) {
        const data = Object.values(electionData).filter(d => d.live)[0];
        setInterval(() => {
          if (data.link && data.year && data.year === this.state.selectedYear) {
            this.props.loadAjaxElectionData(
              data,
              this.state.searches,
              this.state.sort,
              false,
              this.props.force,
            );
          }
        }, 30 * 1000);
      }
    }
  }

  debounce = (func, delay) => {
    let timerId;
    return (...args) => {
      if (timerId) {
        clearTimeout(timerId);
      }
      timerId = setTimeout(() => {
        func(...args);
      }, delay);
    };
  };

  debouncedSearch = this.debounce(searches => {
    this.props.filterData(searches, this.state.sort);
  }, this.DEBOUNCE_DELAY);

  onTabsChange = params => {
    const { year, live, source } = params.clickedItem;
    const { electionData } = this.props.sectionItem.items;
    this.setState({ selectedYear: year, live, source });
    this.props.loadAjaxElectionData(
      electionData[year],
      this.state.searches,
      this.state.sort,
      true,
      this.props.force,
    );
  };

  handleSearchChange = e => {
    const term = e.target.value;
    this.setState({ searches: { ...this.state.searches, slug: term } }, () => {
      this.debouncedSearch(this.state.searches);
    });
  };

  handleStateChange = item => {
    this.setState(
      {
        currentState: { name: item.name, seoname: item.seoname },
        searches: { ...this.state.searches, sn: item.seoname },
      },
      () => {
        this.props.filterData(this.state.searches, this.state.sort);
      },
    );
  };

  reverseSort = e => {
    e.stopPropagation();
    const { alpha = null, margin = null } = this.state.sort;
    const sort = { ...this.state.sort };
    if (alpha) {
      sort.alpha = this.state.sort.alpha * -1;
    }
    if (margin) {
      sort.margin = this.state.sort.margin * -1;
    }
    this.setState({ sort }, () => {
      this.props.filterData(this.state.searches, sort, true);
    });
  };

  render() {
    const { electionData, stateName = '' } = this.props.sectionItem.items;
    return (
      <div className={`${s.constituencyWrap}`}>
        {electionData[this.state.selectedYear] &&
          electionData[this.state.selectedYear].note && (
            <p className={s.noteText}>
              {electionData[this.state.selectedYear].note}
            </p>
          )}
        <div className={s.consTopHead}>
          <div className={s.searchBox}>
            <InputSearch
              placeholder="Search constituencies"
              searchHandler={this.handleSearchChange}
            />
          </div>
          {!this.props.loksabha && (
            <div className={s.sortSearchWrap}>
              <SortSelect
                options={this.sortMapping}
                onSelect={this.reverseSort}
                selectedOption={this.state.sortText}
                sort
                isWapView={this.props.isWapView}
              />
            </div>
          )}
          {this.props.loksabha && (
            <div className={s.sortSearchWrap}>
              <SortSelect
                options={this.props.loksabhaStates}
                onSelect={this.handleStateChange}
                selectedOption={this.state.currentState}
              />
            </div>
          )}
        </div>
        <div className={s.tabWrap}>
          {!this.props.force && (
            <h2 className={s.tabWrapText}>
              List of Constituency {!!stateName && `in ${stateName}`}
            </h2>
          )}
          {this.props.force && (
            <h2 className={s.tabWrapText}>
              List of Constituency{' '}
              {this.state?.currentState?.name &&
                `in ${this.state?.currentState?.name}`}
            </h2>
          )}
          <div className={s.tabs}>
            <span>Results : </span>
            <HeaderTab
              subSections={Object.values(electionData)
                .filter(e => e.url)
                .sort((a, b) => b.year - a.year)}
              onChangeCallback={this.onTabsChange}
              // loading={this.state.loading}
            />
          </div>
        </div>

        {this.props.dataLoading && <LoaderSpinner />}
        <div className="ConstituencyCandidate">
          {this.props.filteredData &&
            Array.isArray(this.props.filteredData) &&
            this.props.filteredData.length === 0 && (
              <div className={s.noDataBox}>
                No such constituency was found. Try searching another one!{' '}
              </div>
            )}
          {this.props.filteredData &&
            Array.isArray(this.props.filteredData) &&
            this.props.filteredData.length > 0 &&
            this.props.filteredData.map(item => (
              <ConstituencyWidget
                title={item.cns_name}
                toBeDecided={item.lw_status === 2 || item.lw_status === 1}
                link={item.link}
                infoText={this.props.loksabha ? item.sn : ''}
              >
                <ConstituencyCandidateVersus
                  candidates={item}
                  toBeDecided={[1, 2, 3, 4].includes(item.lw_status)}
                  loksabha={this.props.loksabha}
                />
              </ConstituencyWidget>
            ))}
        </div>
        {this.state.source && (
          <div className={`${s.source} ${s.cl}`}>
            Source: {this.state.source}
          </div>
        )}
      </div>
    );
  }
}

const mapDispatchtoProps = dispatch => ({
  loadAjaxElectionData: (
    year,
    searches,
    sort,
    loader = false,
    force = false,
  ) => {
    dispatch(loadYearWiseConstituencyData(year, searches, sort, loader, force));
  },
  filterData: (searches, sort, loader = false) => {
    dispatch(filterSearchSortData(searches, sort, loader));
  },
});

const mapStateToProps = state => ({
  filteredData: state.newslisting && state.newslisting.filteredData,
  force: state.newslisting && state.newslisting.force,
  loksabhaStates: state.newslisting && state.newslisting.loksabhaStates,
  loksabha: state.newslisting && state.newslisting.loksabha,
  dataLoading: state?.newslisting?.dataLoading,
});

ConstituencyListWrapper.propTypes = {
  loksabha: false,
  force: false,
  filteredData: PropTypes.objectOf({}),
  loksabhaStates: PropTypes.objectOf({}),
  dataLoading: false,
};
ConstituencyListWrapper.defaultProps = {
  loksabha: false,
  force: false,
  filteredData: {},
  loksabhaStates: {},
  dataLoading: false,
};

export default connect(mapStateToProps, mapDispatchtoProps)(
  ConstituencyListWrapper,
);
